import { isEmptyArray } from '@vy/utils';
import { useMemo } from 'react';
import type { FormattedIntegrationProduct } from '../utils/types/formatted-integration-product';
import { usePaddleProducts } from './requests/integrations';

export function useFormattedPaddleProducts() {
  const { data: { products } = {}, isLoading } = usePaddleProducts({
    keepPreviousData: true,
    suspense: false,
  });

  const formattedProducts = useMemo((): FormattedIntegrationProduct[] => {
    if (isEmptyArray(products)) {
      return [];
    }

    return products.map(({ id, name }) => ({ id, name }));
  }, [products]);

  return {
    products: formattedProducts,
    isLoading,
  };
}
